import React from "react";
import { ReactComponent as SearchIcon } from "../../../icons/search.svg";
import {
  InputWithOptions,
  InputWithOptionsProps,
} from "../InputWithOptions/InputWithOptions";

interface SearchInputProps<T> extends InputWithOptionsProps<T> {
  loading?: boolean;
  disabled?: boolean;
}

const SearchInput = <T extends string | number>({
  loading,
  disabled,
  allowClear = true,
  ...props
}: SearchInputProps<T>) => {
  return (
    <InputWithOptions<T>
      allowClear={allowClear}
      autoTrim={false}
      endIcon={<SearchIcon />}
      disabled={disabled}
      loading={loading}
      {...props}
    />
  );
};

export default SearchInput;
